import ParameterValidator from '@mvps-genesis/parameter-validator';
import {AnticipatedShipDate} from 'custom-extensions/anticipated-ship-date';

export default class AnticipatedShipDates {

	/**
	 * @private
	 * @type {ParameterValidator}
	 */
	#validator;

	/**
	 * @type {HTMLElement}
	 */
	element;

	/**
	 * @constructor
	 * @param {String|HTMLElement} element A selector string or HTMLElement.
	 * @param {AnimationAwaiterOptions} options
	 */
	constructor (element) {
		this.#validator = new ParameterValidator(this);
		this.element = this.#validator.isElement('element', element);
		this.basketShipDates = window.mivaJS.basketShipDates;

		this.init();
	}

	init () {
		const dates = {};
		for (const basketShipDate of this.basketShipDates) {
			const shipsBy = new AnticipatedShipDate({
				anticipatedShipDate: basketShipDate.anticipated_ship_date,
				leadTime: parseInt(basketShipDate.item_lead_time, 10)
			}).get();

			dates[basketShipDate.line_id.toString()] = shipsBy.isValid ? shipsBy.toFormat('MM/dd/y') : basketShipDate.anticipated_ship_date;
		}

		this.element.value = Object.keys(dates).length ? JSON.stringify(dates) : '';
	}
};
